export const BUILD_DATE = "Sun May 18 03:08:18 AM CEST 2025";
export const BUILD_NUMBER = "632";
